import {
	DataTable,
	DataTableHead,
	DataTableHeader,
	DataTableRow,
} from "@walmart-web/livingdesign-components"
import * as React from "react"
import { useIntl } from "react-intl"
import ChartContainer from "components/Shared/ChartContainer"

type Alignment = "left" | "right"

export interface HeaderTableColumn {
	key: string
	title: string
	alignment: Alignment
	width: string
}

interface HeaderTableProps {
	headerColumns: HeaderTableColumn[]
}

export const HeaderTable: React.FC<HeaderTableProps> = ({
	headerColumns,
}): JSX.Element => {
	const intl = useIntl()
	return (
		<DataTableHead>
			<DataTableRow role="table-row-header">
				{headerColumns.map(({ key, title, alignment, width }) => (
					<DataTableHeader key={key} alignment={alignment} width={width}>
						{intl.formatMessage({
							id: title,
						})}
					</DataTableHeader>
				))}
			</DataTableRow>
		</DataTableHead>
	)
}

const Table = ({
	titleTranslationId,
	children,
	isFetching = false,
	className,
}: {
	titleTranslationId: string
	children: React.ReactNode
	isFetching?: boolean
	className?: string
}) => {
	return (
		<ChartContainer
			title={{
				id: titleTranslationId,
			}}
			isLoading={isFetching}
		>
			<DataTable role="data-table" UNSAFE_className={className}>
				{children}
			</DataTable>
		</ChartContainer>
	)
}

export default Table
